export enum LoanOriginationSystemReportingActionType {
  GetReportingDashboardData = 'loanOriginationSystemReporting/getReportingDashboardData',
  SetReportingDashboardStep = 'loanOriginationSystemReporting/setReportingDashboardStep',
  ShowReportingDashboardAdditionalFiltersPopup = 'loanOriginationSystemReporting/showReportingDashboardAdditionalFiltersPopup',
  HideReportingDashboardAdditionalFiltersPopup = 'loanOriginationSystemReporting/hideReportingDashboardAdditionalFiltersPopup',
  SetReportingDashboardIsLoading = 'loanOriginationSystemReporting/setReportingDashboardIsLoading',
  ResetState = 'loanOriginationSystemReporting/resetState',
}
